import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@eig-builder/core-ui/Typography'

import Text from '@eig-builder/module-localization'
import '../lang'

const styles = theme => ({
  rowMargin: {
    marginTop: theme.spacing(4)
  },
  affiliateInfo: {
    maxWidth: 138
  }
})

const AffiliateInfo = ({ classes, account }) => {
  const { irMediaPartner, irMediaPartnerId, irRef } = account
  const hasAffiliateInfo = irMediaPartner && irMediaPartnerId && irRef

  return (
    hasAffiliateInfo && (
      <>
        <div className={`row ${classes.rowMargin}`}>
          <div className='col'>
            <Typography variant='h4'>
              <Text message='modules.crm.components.account.affiliateInfo.title' />
            </Typography>
          </div>
        </div>
        <div className='row'>
          <div className={`col ${classes.affiliateInfo}`}>
            <Typography variant='body2'>
              <Text message='modules.crm.components.account.affiliateInfo.mediaPartner' />
            </Typography>
          </div>
          <div className='col'>
            <Typography variant='body2'>{irMediaPartner}</Typography>
          </div>
        </div>
        <div className='row'>
          <div className={`col ${classes.affiliateInfo}`}>
            <Typography variant='body2'>
              <Text message='modules.crm.components.account.affiliateInfo.mediaPartnerId' />
            </Typography>
          </div>
          <div className='col'>
            <Typography variant='body2'>{irMediaPartnerId}</Typography>
          </div>
        </div>
        <div className='row'>
          <div className={`col ${classes.affiliateInfo}`}>
            <Typography variant='body2'>
              <Text message='modules.crm.components.account.affiliateInfo.refId' />
            </Typography>
          </div>
          <div className='col'>
            <Typography variant='body2'>{irRef}</Typography>
          </div>
        </div>
      </>
    )
  )
}

AffiliateInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired
}

export default withStyles(styles)(AffiliateInfo)
